import * as yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const serialNumber = yup.object().shape({
  serial: yup.number().required().positive(),
});
